import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const obfuscateSensitiveData = ({
  text = '',
  replaceWith = '***',
  charsAtEnd = 3,
  // If the string has no data, generally return an empty string rather than the replacer
  emptyReturns = true,
}) => {
  if (emptyReturns && (text === '' || text === null || !text)) {
    return '';
  }
  if (charsAtEnd > text.length) {
    return replaceWith;
  }
  const front = text.slice(0, charsAtEnd);
  const back = text.slice(charsAtEnd * -1);
  // "fake code should looke like this" => "fak***his"
  return `${front}${replaceWith}${back}`;
};

export { obfuscateSensitiveData };
